import {
  GOLFER_PRODUCT_ACCESS_ASK_PROBLEMS as SharedGolferProductAccessAskProblems,
  GOLFER_PRODUCT_ACCESS_STATUSES as SharedGolferProductAccessStatuses,
} from "shared/dist/types/GolferProductAccess";

export type {
  GolferProductAccess,
  GolferProductAccessAskProblem,
  GolferProductAccessCopy,
  GolferProductAccessStatus,
} from "shared/dist/types/GolferProductAccess";

export const GOLFER_PRODUCT_ACCESS_ASK_PROBLEMS = SharedGolferProductAccessAskProblems;
export const GOLFER_PRODUCT_ACCESS_STATUSES = SharedGolferProductAccessStatuses;
